import { render, staticRenderFns } from "./DeleteUnreleasedRenewals.vue?vue&type=template&id=592a2528&"
import script from "./DeleteUnreleasedRenewals.vue?vue&type=script&lang=js&"
export * from "./DeleteUnreleasedRenewals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports